// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ar-0";
export var orangeButton = "_ar-1";